import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./MyPackage.scss";

export interface IMyPackageProps{
    /**class */
    className?:string;
}

@pureRender
export class MyPackage extends React.Component<IMyPackageProps,any>{
    public render(){
        const {className} =this.props;
        const classNameSec=classnames(styles.sec,className);
        return (
            <div className={classNameSec} onClick={this.myPackage}>
            </div>
        )
    }
    private myPackage=()=>{

        window.Global.isLogin(()=>{
            let descdom=window._CONFIG['PACKAGELINKS'].join("")
            
            new f2eGameUI.Task.PackageDialog({
                actId: window._CONFIG['ACTCODE'],
                dependComponents:{
                    package:{                        
                        pageSize:5,
                        readyText:"加载中..",
                        desc:descdom        
                    },
                    dialog:{
                        classNames:{
                            component:"package-pop"
                        }
                    }
                }
            })
        })
        
    }
}

export default MyPackage;



// WEBPACK FOOTER //
// ./src/components/MyPackage/MyPackage.tsx